import React from "react";
import { faFileLines } from "@fortawesome/pro-regular-svg-icons";
import { useServiceHook } from "rylak-common";
import { fetchEntityActions } from "~/services";
import { ACTION_CATEGORY } from "~/components/entityAction/utils/entityActionsCore.js";
import EntityActionButton from "~/components/entityAction/EntityActionButton.jsx";

export default function GenerateReportButton(props) {
    const { appProps, fullWidth } = props;
    const { serviceData: reportActionsServiceData } = useServiceHook({
        appProps,

        fetchRequested: true,
        fetchData: {
            entityActionCategory: ACTION_CATEGORY.REPORT,
        },
        fetchFn: fetchEntityActions,
    });

    const action = reportActionsServiceData?.data?.[0];

    return (
        <EntityActionButton
            appProps={appProps}
            fullWidth={fullWidth}
            entityAction={action}
            buttonProps={{
                variant: "text",
                icon: faFileLines,
            }}
        />
    );
}
